// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  identity: __t.identity().primaryKey(),
  beat: __t.u32(),
  rollbackTokens: __t.u8().name("rollback_tokens"),
  safetyTutorialDone: __t.bool().name("safety_tutorial_done"),
  theLieRevealed: __t.bool().name("the_lie_revealed"),
  firstHourComplete: __t.bool().name("first_hour_complete"),
  startedAt: __t.timestamp().name("started_at"),
});
